import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const EStatementsRoutes: Routes = [
  {
    path: "e-statements",
    loadComponent: () =>
      import("./e-statements/e-statements.component").then(
        (m) => m.EStatementsComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./e-statements-list/e-statements-list.component").then(
            (m) => m.EStatementsListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./e-statements-form/e-statements-form.component").then(
            (m) => m.EStatementsFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./e-statements-form/e-statements-form.component").then(
            (m) => m.EStatementsFormComponent,
          ),
      },
    ],
  },
];
